import { parseJsonField } from "./parseJson";

export const polygonCentroid = (rawPolygon) => {
  const parsed = parseJsonField(rawPolygon, rawPolygon);
  if (!Array.isArray(parsed) || !parsed.length)
    return { x: null, y: null, z: null };

  const points = [];
  for (let i = 0; i + 2 < parsed.length; i += 3) {
    points.push([parsed[i], parsed[i + 1], parsed[i + 2]]);
  }

  if (!points.length) return { x: null, y: null, z: null };

  const sum = points.reduce(
    (acc, [x, y, z]) => {
      acc.x += Number(x) || 0;
      acc.y += Number(y) || 0;
      acc.z += Number(z) || 0;
      return acc;
    },
    { x: 0, y: 0, z: 0 },
  );

  return {
    x: sum.x / points.length,
    y: sum.y / points.length,
    z: sum.z / points.length,
  };
};
